import { required, validEmail } from '@utils/validators';
import { FormValues } from '../SignIn.types';
import { ValidationResult } from './SignInModalForm.types';

export const validate = (values: FormValues): ValidationResult => {
  const errors: ValidationResult = {};

  errors.email = required(values.email) || validEmail(values.email);
  errors.password = required(values.password);

  return errors;
};
